import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get, isEmpty, size } from 'lodash'
import { Container, Typography } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import moment from 'moment'

import CustomTable from '../../components/table/CustomTable'
import { fetchData } from '../../api/api'
import ButtonBackHeader from '../../components/ButtonBackHeader/ButtonBackHeader'
import detailsStyles from './css/detailsStyles'

const headCellsSku = [{ id: 'id', numeric: false, order: false, label: 'SKU' }]

const createSkuRows = ({ id = '-' }) => {
  return { id }
}

const Details = ({ location }) => {
  const classes = detailsStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const orderData = get(location, 'state.row') || {}
  const fetchObject = get(location, 'state.fetchObject') || {}

  const [tableRows, setTableRows] = useState([])
  const [curretPage, setCurrentPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const [numberOfPages, setNumberOfPages] = useState(1)
  const [selectedRows, setSelectedRows] = useState([])
  const [isDataLoading, setIsDataLoading] = useState(false)

  const handleActionButtonClick = () => {
    if (isEmpty(selectedRows))
      return enqueueSnackbar('Ningun SKU seleccionado', {
        variant: 'error',
        autoHideDuration: 1000,
      })
    return history.push({
      pathname: 'ticket-imprimir',
      state: {
        selectedRows: [...selectedRows],
        orderData: { ...orderData },
      },
    })
  }

  useEffect(() => {
    const fetchFormData = async () => {
      setIsDataLoading(true)
      try {
        const tableDataApi = await fetchData({
          orden: get(orderData, 'id'),
          transaction: get(orderData, 'numeroTrx'),
          dateTransaction: moment(get(orderData, 'fecha') || '', 'YYYY-MM-DD').format('DD-MM-YYYY'),
          sucursal: get(orderData, 'sucursalCom'),
          caja: get(orderData, 'caja'),
          size: rowsPerPage,
          page: curretPage,
          userAuthKey: get(fetchObject, 'userAuthKey'),
          action: 'sku',
          view: 'serve',
        })
        setNumberOfPages(get(tableDataApi, 'pages.total') || 1)
        const tableData = get(tableDataApi, 'data.data') || []
        setTableRows(
          tableData.map(row =>
            createSkuRows({
              id: get(row, 'codigoArticulo') || '',
            })
          )
        )

        setSelectedRows(tableData.map(row => get(row, 'codigoArticulo') || ''))

        return setIsDataLoading(false)
      } catch (error) {
        setIsDataLoading(false)
        return error
      }
    }
    fetchFormData()
  }, [rowsPerPage, curretPage])

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <ButtonBackHeader
          buttonText="Generar Ticket"
          onActionButtonClick={handleActionButtonClick}
          icon="arrowRight"
          disableActionButton={size(selectedRows) === 0}
        />
        <Typography variant="h5">Detalle de transacción</Typography>
        <Typography variant="body1" gutterBottom color="textSecondary">
          Compra hecha el {get(orderData, 'fecha') || '-'}
        </Typography>

        <CustomTable
          className={classes.table}
          rows={tableRows}
          headCells={headCellsSku}
          actionTable
          eraseButton
          page={curretPage}
          setPage={setCurrentPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          order={order}
          setOrder={setOrder}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          isDataLoading={isDataLoading}
          numberOfPages={numberOfPages}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          checkTable
        />
      </Container>
    </div>
  )
}

Details.propTypes = {}

export default Details
